export const getViewportTime = (duration: number, pos: number, zoom: number) => {
    const zoomDuration = duration / zoom
  
    const min = Math.max(0, duration * pos - zoomDuration / 2)
    const max = Math.min(duration, min + zoomDuration)
  
    return { min, max }
  }  